import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import EditorLink from '@wix/da-ds/pkg/Icons/24x24/EditorLink';
import { ButtonProps } from './types';
import {
  isBlockNodeActive,
  isElementGroupInSelection,
  isExtensionInstalled,
  selectionHasLinkMark,
} from '../../utils/tiptap';
import EditorIconButton from '../_partials/EditorIconButton';

const Link: React.FC<ButtonProps> = ({ editor, hideWhenNotEnabled = true }) => {
  const { t } = useTranslation('editor');
  const setLink = useCallback(() => {
    if (!editor) {
      return;
    }
    if (selectionHasLinkMark(editor)) {
      editor.chain().extendMarkRange('link').editLinkInBubbleMenu().run();
    } else {
      editor?.commands.openLinkBubbleMenu({ isNew: true });
    }
  }, [editor]);

  if (
    !editor.isEditable ||
    (hideWhenNotEnabled && !isExtensionInstalled(editor, 'link'))
  ) {
    return null;
  }

  return (
    <EditorIconButton
      featureId="node:link"
      icon={EditorLink}
      onClick={setLink}
      tooltipText={t('ext.link.editorToolbar.button.tooltip')}
      aria-label={t('ext.link.editorToolbar.button.tooltip')}
      disabled={
        isBlockNodeActive(editor, 'unlinkable') ||
        isElementGroupInSelection(editor, 'unlinkable')
      }
    />
  );
};
Link.displayName = 'Link';

export default Link;
